import { useState, useEffect, useCallback } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { lazy, Suspense } from "react";

const BookingForm = lazy(() => import("./BookingForm").then(m => ({ default: m.BookingForm })));

interface ConsultaPopupProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ConsultaPopup({ isOpen, onOpenChange }: ConsultaPopupProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl w-[95vw] p-0 bg-[#FDF8F5] rounded-[2rem] border-none overflow-hidden max-h-[90vh] flex flex-col shadow-2xl">
        <DialogTitle className="sr-only">Agendar Consulta - Dra. Adriana Rodrigues</DialogTitle>
        <div className="flex-1 overflow-y-auto min-h-[400px]">
          <Suspense fallback={
            <div className="flex items-center justify-center h-full min-h-[400px]">
              <div className="w-8 h-8 rounded-full border-4 border-primary border-t-transparent animate-spin"></div>
            </div>
          }>
            {isOpen && <BookingForm />}
          </Suspense>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// Global state hook for the popup
let openPopupFn: (() => void) | null = null;

export function useConsultaPopup() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    openPopupFn = () => setIsOpen(true);
    return () => {
      openPopupFn = null;
    };
  }, []);

  return {
    isOpen,
    setIsOpen,
    openPopup: useCallback(() => setIsOpen(true), []),
  };
}

export function triggerConsultaPopup() {
  if (openPopupFn) {
    openPopupFn();
  } else {
    // Fallback if component not mounted yet
    window.open('https://api.whatsapp.com/send?phone=5515981672457&text=Olá, gostaria de agendar uma consulta', '_blank');
  }
}
